<!-- My Scanners -->
<div class="py-4 px-6 dark:text-gray-200">
  <table class="text-sm w-full mt-4 shadow-md rounded-md">
    <thead class="dark:bg-app-black-100">
      <tr>
        <th class="py-2 px-4 text-left text-lg text-white" colspan="2">My Scanners</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let scanner of scanners" class="even:bg-app-black-100/30 hover:bg-app-teal-100/10">
        <td class="py-2 px-4">
          <!-- If neither Url nor AppUrl is set, render plain text (no link icon, no click).
               The scanner row still appears so admins can see what's configured,
               but it isn't navigable from here. -->
          <!-- Link icon turns red when the most recent verify probe failed
               (verified.ok === false). Never-verified scanners keep the
               default teal icon — we don't want to penalise rows that
               just haven't been probed yet. -->
          <a *ngIf="scanner.Url || scanner.AppUrl"
             class="hover:underline cursor-pointer text-white"
             (click)="navigate_to_scanner(scanner, $event)"
             [title]="scanner.verified && !scanner.verified.ok ? ('Last verified ' + (scanner.verified.checked_at || '') + ': HTTP ' + (scanner.verified.status || '?') + (scanner.verified.error ? ' — ' + scanner.verified.error : '')) : ''">
            <i class="fa-solid fa-arrow-up-right-from-square fa-fw mr-2"
               [class.text-app-teal-100]="!scanner.verified || scanner.verified.ok"
               [class.text-red-500]="scanner.verified && !scanner.verified.ok"></i>{{scanner.Name}}
          </a>
          <span *ngIf="!scanner.Url && !scanner.AppUrl" class="text-gray-500">
            <i class="fa-solid fa-link-slash fa-fw mr-2"></i>{{scanner.Name}}
          </span>
        </td>
        <td *ngIf="authService.is_admin()" class="py-2 px-4 text-xs text-gray-500 text-right">
          <span class="inline-flex items-center gap-2 justify-end">
            <button *ngIf="scanner.Url || scanner.AppUrl"
                    type="button"
                    (click)="copyScannerUrl(scanner, $event)"
                    [title]="'Copy URL: ' + (scanner.Url || scanner.AppUrl)"
                    class="text-[10px] uppercase tracking-[1px] border border-gray-700 hover:border-app-teal-100 text-gray-400 hover:text-app-teal-100 rounded px-1.5 py-0.5 transition">
              <ng-container *ngIf="copiedScannerId === scanner.Id">✓ Copied</ng-container>
              <ng-container *ngIf="copiedScannerId !== scanner.Id"><i class="fa-regular fa-copy mr-1"></i>Copy</ng-container>
            </button>
            <span>{{ scanner.Url || scanner.AppUrl }}</span>
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</div>

